import AlertService from '@/shared/alert/alert.service';
import { DatosGeneralesApi } from '@/shared/perfil-usuario';
import { Component, Inject, Vue } from 'vue-property-decorator';

@Component
export default class PdfPuComponent extends Vue {
  @Inject('miPerfilApi') private miPerfilApi: () => DatosGeneralesApi;
  @Inject('alertService') private alertService: () => AlertService;

  public encryptedCvu = '';
  public contenidoBase64 = '';
  public pdfReady = false;
  public showOverlay = false;

  mounted() {
    this.encryptedCvu = this.$route.params.cvu;
    this.vistaPrevia(this.encryptedCvu);
  }

  /**
   * Genera la vista previa de un documento PDF dado un cvu encriptado
   *
   */
  public vistaPrevia(encryptedCvu: string) {
    this.showOverlay = true;
    this.contenidoBase64 = '';
    this.pdfReady = false;

    this.miPerfilApi()
      .getReportePdfPu(encryptedCvu)
      .then(res => {
        this.contenidoBase64 = `data:application/pdf;base64,${res.data.contenidoBase64}`;
        this.pdfReady = true;
        this.showOverlay = false;
      })
      .catch(() => {
        this.alertService().showError(this, this.$t('perfil-unico.error-descarga').toString());
        this.showOverlay = false;
      });
  }

  public openHome() {
    sessionStorage.removeItem('requested-url');
    // eslint-disable-next-line no-multi-assign
    window.location.href = window.location.href = '/';
  }
}
